import { Countries } from '../types';

type CountryUrls = { [key in Countries]: string };

const HOSTS: CountryUrls = {
  AE: 'https://www.groupon.ae',
  AU: 'https://www.groupon.com.au',
  BE: 'https://www.groupon.be',
  CA: 'https://www.groupon.ca',
  DE: 'https://www.groupon.de',
  ES: 'https://www.groupon.es',
  FR: 'https://www.groupon.fr',
  GB: 'https://www.groupon.co.uk',
  IE: 'https://www.groupon.ie',
  IT: 'https://www.groupon.it',
  JP: 'https://www.groupon.jp',
  NL: 'https://www.groupon.nl',
  NZ: 'https://www.grouponnz.co.nz',
  PL: 'https://www.groupon.pl',
  US: 'https://www.groupon.com',
};

export const DATA_PRIVACY_URLS: CountryUrls = {
  AE: `${HOSTS.AE}/merchant/data-privacy`,
  AU: `${HOSTS.AU}/privacy`,
  BE: `${HOSTS.BE}/merchant/data-privacy`,
  CA: `${HOSTS.CA}/privacy`,
  DE: `${HOSTS.DE}/merchant/data-privacy`,
  ES: `${HOSTS.ES}/merchant/data-privacy`,
  FR: `${HOSTS.FR}/merchant/data-privacy`,
  GB: `${HOSTS.GB}/merchant/data-privacy`,
  IE: `${HOSTS.IE}/merchant/data-privacy`,
  IT: `${HOSTS.IT}/merchant/data-privacy`,
  JP: `${HOSTS.JP}/pages/vendor-code-of-conduct`,
  NL: `${HOSTS.NL}/merchant/data-privacy`,
  NZ: `${HOSTS.NZ}/privacy`,
  PL: `${HOSTS.PL}/merchant/data-privacy`,
  US: `${HOSTS.US}/privacy`,
};

export const TOS_URLS: CountryUrls = {
  AE: `${HOSTS.AE}/merchant/terms-of-use`,
  AU: `${HOSTS.AU}/merchant/terms-of-use`,
  BE: `${HOSTS.BE}/merchant/terms-of-use`,
  CA: `${HOSTS.CA}/merchant/terms-of-use`,
  DE: `${HOSTS.DE}/merchant/terms-of-use`,
  ES: `${HOSTS.ES}/merchant/terms-of-use`,
  FR: `${HOSTS.FR}/merchant/terms-of-use`,
  GB: `${HOSTS.GB}/merchant/terms-of-use`,
  IE: `${HOSTS.IE}/merchant/terms-of-use`,
  IT: `${HOSTS.IT}/merchant/terms-of-use`,
  JP: `${HOSTS.JP}/merchant/terms-of-use`,
  NL: `${HOSTS.NL}/merchant/terms-of-use`,
  NZ: `${HOSTS.NZ}/merchant/terms-of-use`,
  PL: `${HOSTS.PL}/merchant/terms-of-use`,
  US: `${HOSTS.US}/merchant/legal/terms-of-use`,
};

export const getTermsOfUseUrl = (country: Countries): string => {
  return TOS_URLS[country];
};

export const getDataPrivacyUrl = (country: Countries): string => {
  return DATA_PRIVACY_URLS[country];
};
